import React from 'react';
import profileService from '../../services/profileService';

export default class ResetPassword extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            password: '',
            confirmation: '',
            hash: this.props.match.params.hash,
            error: null
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.options = {
            autoClose: 3000,
            hideProgressBar: true,
        };
    }

    handleChange = event => {
        this.setState({
            [event.target.name]: event.target.value,
            error: null
        });
    }


    handleSubmit = event => {
        event.preventDefault();
        if (this.validateForm()) {
            profileService.resetPassword(this.state.hash, this.state)
                .then(response => {
                    this.props.history.push("/");
                }).catch(error => {
                    this.setState({ error: "All field are required!" })
                });
        } else {
            this.setState({ error: "All field are required!" })
        }
    }

    validateForm() {
        return this.state.password && this.state.password;
    }

    render() {
        const { password, confirmation, error } = this.state;
        return (
            <div className="auth-page-container container-fluid">
                <div className="auth-frame jumbotron">
                    <div className="auth-img-box ">
                        <img
                            className="auth-logo"
                            src='/assets/images/logo.png'
                            alt="AirTouch logo"
                        />
                    </div>
                    <form onSubmit={this.handleSubmit} className="text-left">
                        <div className="form-group">
                            <label htmlFor="email">New password:</label>
                            <input id='password' className="form-control" type="password" name="password" value={password} onChange={this.handleChange} />
                        </div>
                        <div className="form-group">
                            <label htmlFor="confirmation">Confirm password:</label>
                            <input id='confirmation' className="form-control" type="password" name="confirmation" value={confirmation} onChange={this.handleChange} />
                        </div>
                        {error &&
                            <div className={'alert alert-danger'}>{error}</div>
                        }
                        <div className="text-right">
                            <button type="submit" className="btn btn-lightblue">Submit</button>
                        </div>
                    </form>
                </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/resetPassword/reset.js